import { HLJ_MERCHANT_MY_COUNT } from '@merchant-backend/common-components/src/Head/constant'
import { isHotelProperty } from '@merchant-backend/util'
import { getJti, getMerchantInfo, isSiYiTeam } from '@util'
import { Button, message, Modal, Progress, Tabs } from 'hljd'
import { observer, Provider } from 'mobx-react'
import React, { Component } from 'react'
import MobileShop from '../../Decoration/Home/MobileShop'
import MobileShopHomeStore from '../../Decoration/Home/store'
import { EXAMPLE } from './constant'
import FinishedModal from './FinishedModal'
import Hotel from './Hotel'
import Store from './store'
import styles from './style.module.less'
import { PUBLISH_WORK_TASK_ID } from '@components/LocalMerchant/Home/TaskOfOpeningShop/store'
const { TabPane } = Tabs
const STATUS = {
  '0': 'btn_todo', //未完成
  '1': 'btn_audit', //待审核中
  '2': 'btn_error', //审核未通过
  '3': 'btn_finish' //已完成
}

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.mobileStore = new MobileShopHomeStore({
      mode: 'preview',
      showAll: 'all',
      theme: '0'
    })
    this.store = new Store()
  }

  handleGoto(link, item) {
    // 司仪团队发布作品任务时，如果团队成员为空，则报错提示
    if (
      isSiYiTeam() &&
      item.id === PUBLISH_WORK_TASK_ID &&
      this.store.memberList?.length === 0
    ) {
      message.error('请先创建团队成员')
      return
    }
    // 司仪改版@鱼香 要求所有任务都打开新窗口了
    if (link === '/hlj-merchant-center/dist/index.html#/my/account') {
      window.open(HLJ_MERCHANT_MY_COUNT + getJti())
    } else {
      window.open(link)
    }
  }

  componentDidMount() {
    this.mobileStore.getHomeData()
    this.mobileStore.getAllStatus()
    this.store.getData()
  }

  render() {
    const {
      data: {
        completeCount,
        totalCount,
        prompt,
        subPrompt,
        taskList = [],
        workWechat = {}
      },
      visible,
      showModal,
      finishTask
    } = this.store
    const { property_id } = getMerchantInfo()

    return (
      <Provider decorationStore={this.mobileStore}>
        <>
          <div className={styles.box}>
            <div className={styles.left}>
              <div className={styles.topBox}>
                <div className={styles.progress}>
                  <div className={styles.inner}>
                    <Progress
                      type="circle"
                      percent={((completeCount * 100) / totalCount).toFixed(2)}
                      width={70}
                    />

                    <div className={styles.des}>
                      <p className={styles.p1}>{prompt}</p>
                      <div style={{ color: '#666', marginTop: 4 }}>
                        <div
                          style={{ fontFamily: 'PingFangSC-Regular' }}
                          dangerouslySetInnerHTML={{ __html: subPrompt }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <img
                  src="https://qnm.hunliji.com/FiB266B7wiKzRmpO4LI7Pf9AahYH"
                  width={320}
                />
                {workWechat.qrCode && (
                  <div className={styles.button}>
                    <Button type="primary" onClick={showModal}>
                      添加运营微信
                    </Button>
                  </div>
                )}
                {completeCount != null &&
                  totalCount != null &&
                  completeCount == totalCount && (
                    <FinishedModal onFinish={finishTask} />
                  )}
              </div>
              <div className={styles.details}>
                {taskList.map(item => (
                  <div className={styles.item} key={item.id}>
                    <div className={styles.inner}>
                      <div className={styles.icon}>
                        <img src={item.icon + '?imageView/2/w/72'} />
                      </div>
                      <div className={styles.task}>
                        <p className={styles.p1}>
                          {item.taskName}
                          {// 限时免费标签
                          item.mark && (
                            <span className={styles.freeLimitTime}>
                              {item.mark}
                            </span>
                          )}
                        </p>
                        <p className={styles.p2}>{item.taskDeputyCopywriter}</p>
                      </div>
                    </div>
                    <div
                      className={`${styles.btn} ${styles[STATUS[item.status]]}`}
                    >
                      <a
                        onClick={() => this.handleGoto(item.webRoute, item)}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {item.buttonText}
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className={styles.right}>
              <Tabs>
                <TabPane tab="您的店铺" key="1">
                  <div className={styles.bg}>
                    <div
                      className={styles.innerBox}
                      style={{ paddingBottom: isHotelProperty() ? '60px' : '' }}
                    >
                      {isHotelProperty() ? (
                        <Hotel />
                      ) : (
                        <MobileShop
                          store={this.mobileStore}
                          useForHomePage={true}
                        />
                      )}
                    </div>
                    {isHotelProperty() && (
                      <img
                        className={styles.footer}
                        src="https://qnm.hunliji.com/FuLm8PpZphviQKLHoOZXrEtqByYP"
                        width={375}
                      />
                    )}
                  </div>
                </TabPane>
                <TabPane tab="示例店铺" key="2">
                  <div className={styles.bg}>
                    <div className={styles.innerBox}>
                      <img src={EXAMPLE[property_id] + '?imageView/2/w/375'} />
                    </div>
                  </div>
                </TabPane>
              </Tabs>
            </div>
          </div>

          <Modal
            visible={visible}
            onCancel={showModal}
            footer={null}
            width={320}
          >
            <p className={styles.p3}>微信扫一扫，立即添加运营</p>
            <div className={styles.code}>
              <img src={workWechat.qrCode} width={140} />
            </div>
          </Modal>
        </>
      </Provider>
    )
  }
}
